import React from 'react';
import { useIntl } from 'react-intl';
import { withBlockExtensions } from '@plone/volto/helpers';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { MaplibreBlockSchema } from '@codesyntax/volto-maplibre-block/components/Blocks/MaplibreBlock/schema';
import MaplibreBlockView from './View';

export const MaplibreBlockEdit = (props) => {
  const { block, data, selected } = props;
  const handleChange = (id, value) => {
    props.onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  const intl = useIntl();
  const schema = MaplibreBlockSchema(intl);

  return (
    <>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          onChangeField={handleChange}
          onChangeBlock={props.onChangeBlock}
          block={block}
        />
      </SidebarPortal>
      <MaplibreBlockView data={data} />
    </>
  );
};

export default withBlockExtensions(MaplibreBlockEdit);
